/**
 * Alpine host for the location prompts that the server lists in `pending_prompts` (docs#10).
 *
 * The server renders the first prompt kind the web knows into
 * layouts/partials/location-prompt-host.twig. This component shows it at most once per browser
 * tab session, and its dismiss() clears the prompt on the server.
 */

import apiClient from '../api-client.js';

export const SESSION_KEY = 'locationPrompt:shown';

/** True when this tab has not shown a location prompt yet. Claims the slot. */
export function claimSessionSlot(storage) {
    try {
        if (storage.getItem(SESSION_KEY) !== null) {
            return false;
        }
        storage.setItem(SESSION_KEY, '1');
        return true;
    } catch {
        // Without sessionStorage the host cannot keep the once-per-session rule, so it shows nothing.
        return false;
    }
}

export function locationPromptHost(kind) {
    return {
        kind,
        visible: false,
        busy: false,

        init() {
            this.visible = claimSessionSlot(window.sessionStorage);
        },

        async dismiss() {
            if (this.busy) {
                return;
            }
            this.busy = true;
            this.visible = false;
            try {
                await apiClient.request(`/location-prompts/${encodeURIComponent(this.kind)}/dismiss`, {
                    method: 'POST',
                });
            } catch {
                // The prompt stays pending on the server and can show again in a later session.
            } finally {
                this.busy = false;
            }
        },
    };
}
